export default class Util {
  static toBoolean(from: any) {
    if (typeof from === 'boolean') {
      return from;
    } else if (typeof from === 'string') {
      return from === 'true';
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/util.ts